import { render } from "./StudioConfirmationDialog.vue?vue&type=template&id=f04befc0&scoped=true&ts=true"
import script from "./StudioConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./StudioConfirmationDialog.vue?vue&type=script&lang=ts"

import "./StudioConfirmationDialog.vue?vue&type=style&index=0&id=f04befc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04befc0"]])

export default __exports__